module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'primary': '#0B3D52',
                    'grip-navy': '#0B3D52',
                    'grip-turquoise': '#0AB3B7',
                    'grip-mint': '#B2DFD8',
                    'gray': '#0B3D5240',
                }
            },
        },
        fontFamily: {
            kanit: ['Kanit', 'sans-serif'],
            lato: ['Lato', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('tailwind-scrollbar'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
